$('body').on('click','.thickbox_cont_static .close-js',function(e) {
    e.preventDefault();
    $('#overlay').removeClass('active');
    $(this).parents('.thickbox_cont_static').removeClass('active');
});
$('.close_edit_popup').on('click',function () {
    $('#overlay').removeClass('active');
    $(this).parents('.modal_edit_success').hide();
})
